import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import colors from 'vuetify/lib/util/colors'

Vue.use(Vuetify)

export default new Vuetify({
  icons: {
    iconfont: 'mdiSvg' // 'mdi' || 'mdiSvg' || 'md' || 'fa' || 'fa4'
  },
  theme: {
    dark: false,
    themes: {
      light: {
        primary: colors.red.lighten2,
        secondary: colors.red.accent2,
        background: colors.grey.lighten4,
        toolbar: '#FFF',
        drawerselected: '#ECECEC'
      },
      dark: {
        background: '#000000',
        drawerselected: colors.red.accent2
      }
    },
    options: {
      customProperties: true
    }
  }
})
